/* XS Mega menu behaviour. Desktop: hover/focus panels. Phone: layered drawer. */
(function () {
  'use strict';

  document.querySelectorAll('.xsm').forEach(function (root) {
    /* ---------------------------------------------------------- desktop -- */
    var items = Array.prototype.slice.call(root.querySelectorAll('.xsm-has-panel'));
    var openTimer = null, closeTimer = null;

    function closeAll() {
      items.forEach(function (li) {
        var p = li.querySelector('.xsm-panel');
        var b = li.querySelector('.xsm-bar__link');
        if (p) p.setAttribute('data-open', 'false');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    function open(li) {
      closeAll();
      var p = li.querySelector('.xsm-panel');
      var b = li.querySelector('.xsm-bar__link');
      if (p) p.setAttribute('data-open', 'true');
      if (b) b.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(li); }, 90);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(closeAll, 180);
      });
      li.addEventListener('focusin', function () { open(li); });
    });

    // Accessibility, 29 Oct 2026: Escape used to close the panel while focus
    // sat on a link inside it, which dropped focus to <body>. Now focus returns
    // to that item's top-level link. And tabbing out of the menu entirely
    // closes any open panel instead of leaving it covering the page.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var li = e.target.closest && e.target.closest('.xsm-has-panel');
      closeAll();
      if (li) {
        var b = li.querySelector('.xsm-bar__link');
        if (b && b !== e.target) b.focus({ preventScroll: true });
        // focusing the bar link re-opens via focusin; close it again
        closeAll();
      }
    });
    root.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    /* ----------------------------------------------------------- mobile -- */
    var drawer = root.querySelector('.xsm-drawer');
    if (!drawer) return;
    var scrim = root.querySelector('.xsm-scrim');
    var slider = root.querySelector('.xsm-slider');
    var back = root.querySelector('.xsm-back');
    var title = root.querySelector('.xsm-drawer__title');
    var closeBtn = root.querySelector('.xsm-drawer__close');
    var levels = Array.prototype.slice.call(root.querySelectorAll('.xsm-level'));
    var stack = [{ index: 0, label: 'Shop' }];
    var lastFocus = null;

    function render() {
      var top = stack[stack.length - 1];
      slider.style.transform = 'translateX(-' + (top.index * 100) + '%)';
      back.setAttribute('data-show', stack.length > 1 ? 'true' : 'false');
      title.textContent = top.label;
      levels.forEach(function (l, i) {
        l.setAttribute('aria-hidden', i === top.index ? 'false' : 'true');
      });
    }

    function openDrawer(startIndex, label) {
      lastFocus = document.activeElement;
      stack = [{ index: 0, label: 'Shop' }];
      if (startIndex) stack.push({ index: startIndex, label: label });
      render();
      drawer.setAttribute('data-open', 'true');
      scrim.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeDrawer() {
      drawer.setAttribute('data-open', 'false');
      scrim.setAttribute('data-open', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll('[data-xsm-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(parseInt(btn.getAttribute('data-xsm-open'), 10) || 0, btn.textContent.trim());
      });
    });

    root.querySelectorAll('[data-xsm-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        stack.push({
          index: parseInt(btn.getAttribute('data-xsm-go'), 10),
          label: btn.getAttribute('data-xsm-label') || btn.textContent.trim()
        });
        render();
      });
    });

    back.addEventListener('click', function () { stack.pop(); render(); });
    closeBtn.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
    });

    render();
  });
}());
